
document.addEventListener("DOMContentLoaded", function () {
  const eventBlocks = document.querySelectorAll(".event-block");

  eventBlocks.forEach(block => {
    const dateStr = block.getAttribute("data-event-date");
    const endDateStr = block.getAttribute("data-event-end-date");
    const eventDate = new Date(dateStr);
    const endDate = endDateStr ? new Date(endDateStr) : null;
    const now = new Date();

    const isPast = endDate ? endDate < now : eventDate < now;

    const statusEl = block.querySelector(".event-status");
    const rsvpBtn = block.querySelector(".event-rsvp");

    if (statusEl) {
      statusEl.textContent = isPast ? "Past" : "Upcoming";
      statusEl.classList.add("event-badge");
      statusEl.classList.add(isPast ? "past-badge" : "upcoming-badge");
      statusEl.style.display = "inline-block";
    }

    if (rsvpBtn) {
      rsvpBtn.style.display = isPast ? "none" : "inline-block";
    }
  });
});
